export default function Testimonials() {
  const reviews = [
    {
      quote: '自从发现了非麻瓜漫画，我的每天通勤时间都变得有意义了。下拉式阅读体验太棒了，画质清晰，更新也很快，强烈推荐！',
      name: '小雨同学',
      role: '忠实读者 · 使用2年',
      avatar: 'https://readdy.ai/api/search-image?query=Cute%20anime%20style%20girl%20avatar%20with%20long%20black%20hair%20and%20warm%20smile%2C%20soft%20lighting%2C%20simple%20cream%20background%2C%20chibi%20inspired%20portrait&width=200&height=200&seq=testimonial-avatar-01&orientation=squarish',
    },
    {
      quote: '做为韩漫爱好者，非麻瓜漫画是我用过最舒服的阅读平台。资源丰富，分类清晰，而且完全免费，真的太良心了！',
      name: '漫画达人阿杰',
      role: '白金会员 · 使用3年',
      avatar: 'https://readdy.ai/api/search-image?query=Cool%20anime%20style%20boy%20avatar%20with%20stylish%20hair%20and%20confident%20expression%2C%20simple%20warm%20background%2C%20chibi%20inspired%20portrait&width=200&height=200&seq=testimonial-avatar-02&orientation=squarish',
    },
    {
      quote: '每天必刷的网站！更新速度真的很快，很多热门漫画都是第一时间上线。下拉式阅读模式对于手机党来说简直不要太友好。',
      name: '追更小能手',
      role: '黄金会员 · 使用1年',
      avatar: 'https://readdy.ai/api/search-image?query=Cheerful%20anime%20style%20girl%20avatar%20with%20twin%20tails%20and%20bright%20eyes%2C%20energetic%20vibe%2C%20simple%20background%2C%20chibi%20inspired%20portrait&width=200&height=200&seq=testimonial-avatar-03&orientation=squarish',
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-foreground-950">
      <div className="w-full px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-foreground-800 text-foreground-200 text-xs font-medium rounded-full mb-3">
            读者口碑
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-background-50">
            读者们都在说
          </h2>
          <p className="mt-2 text-sm text-foreground-400">听听漫画爱好者们的声音</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {reviews.map((review) => (
            <div
              key={review.name}
              className="relative bg-foreground-900 rounded-lg p-6 md:p-7"
            >
              <span className="text-5xl font-heading text-background-50/15 absolute top-4 left-5 leading-none">
                &ldquo;
              </span>
              <p className="relative z-10 text-sm text-foreground-200 leading-relaxed pt-4">
                {review.quote}
              </p>
              <div className="mt-5 flex items-center gap-3">
                <img
                  src={review.avatar}
                  alt={review.name}
                  className="w-10 h-10 rounded-full object-cover"
                  loading="lazy"
                />
                <div>
                  <p className="text-sm font-medium text-background-50">{review.name}</p>
                  <p className="text-xs text-foreground-500">{review.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}